import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { getDatabase, ref, onValue } from "firebase/database";
import { useNavigate } from "react-router-dom";
import "../../styles/UX/FlashPopUp.css";
import exit from "../../assets/exit.png";
import whiteLoader from "../../assets/loader (2).gif";
import { getProductById } from "../../Utils/Utils";

const FlashPopUp = ({ darkMode }) => {
  const navigate = useNavigate();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [associatedProduct, setAssociatedProduct] = useState(null);
  const [flashSaleContent, setFlashSaleContent] = useState({
    flashSaleStatus: false,
    mediaType: "photo",
    mediaContent: [],
    flashSaleContent: "",
    associatedProduct: null,
  });
  const [productImages, setProductImages] = useState([]);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const db = getDatabase();
    const flashSaleRef = ref(db, "flash-sales");

    onValue(flashSaleRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const active = Object.values(data).find((item) => item.flashSaleStatus === true);
        if (active) {
          setFlashSaleContent(active);
          // Delay popup between 2s-5s: use entrance animation delay and also make visible after 2s
          setTimeout(() => setIsVisible(true), 2000);
        } else {
          setIsVisible(false);
        }
      } else {
        setIsVisible(false);
      }
    });
  }, []);

  useEffect(() => {
    console.log("Flash Sale Content Updated:", flashSaleContent);
    const fetchAssociatedProduct = async () => {
      if (flashSaleContent.associatedProduct) {
        try {
          const product = await getProductById(flashSaleContent.associatedProduct);
          if (product && product.imagesUrls) {
            setAssociatedProduct(product);
            setProductImages(product.imagesUrls);
          } else {
            setProductImages([]);
          }
        } catch (error) {
          console.error("Error fetching product:", error);
          setProductImages([]);
        }
      } else {
        setProductImages([]);
      }
    };

    fetchAssociatedProduct();

    const imagesToUse = associatedProduct && associatedProduct.imagesUrls && associatedProduct.imagesUrls.length > 0 ? associatedProduct.imagesUrls : flashSaleContent.mediaContent || [];
    if (
      flashSaleContent.mediaType === "slider" &&
      imagesToUse.length > 0
    ) {
      const interval = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % imagesToUse.length);
      }, 5000);
      return () => clearInterval(interval);
    }
  }, [flashSaleContent]);

  const closeSale = () => setIsVisible(false);

  const handleFlashClick = () => {
    if (!flashSaleContent?.associatedProduct) return;
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      navigate(`/product-details/${flashSaleContent.associatedProduct}`);
      setIsVisible(false);
    }, 3000);
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ x: "-100%", opacity: 0 }}
          animate={{ x: 0, opacity: 1, transition: { delay: 3 } }}
          exit={{ x: "-100%", opacity: 0 }}
          className={
            darkMode
              ? flashSaleContent.mediaType !== "photo"
                ? "dark-mode flash-sale-container video-flash"
                : "dark-mode flash-sale-container"
              : flashSaleContent.mediaType !== "photo"
              ? "flash-sale-container video-flash"
              : "flash-sale-container"
          }
        >
          <div
            className={darkMode ? "inverted-image overlay-close-btn" : "overlay-close-btn"}
            onClick={closeSale}
          >
            <img src={exit} alt="Fermer la promotion" />
          </div>

          {flashSaleContent.mediaType === "photo" ? (
            <div className="flex-column  bold align-items-center">
              <motion.img
                key={currentIndex}
                src={
                  associatedProduct && associatedProduct.imagesUrls && associatedProduct.imagesUrls.length > 0
                    ? associatedProduct.imagesUrls[currentIndex]
                    : flashSaleContent.mediaContent && flashSaleContent.mediaContent.length > 0
                    ? flashSaleContent.mediaContent[currentIndex]
                    : null
                }
                alt="Image de la promotion"
                className="flash-sale-image"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.5 }}
              />
<p className={darkMode ? "smaller-text white center-text" : "center-text smaller-text black"}>
                {associatedProduct && associatedProduct.productName }
              </p>
              <p className={darkMode ? "small-text white" : "small-text black"}>
                {flashSaleContent.flashSaleContent}
              </p>

              <div className="action-button bg-blue my-10" onClick={handleFlashClick}>
                <motion.p className="btn small-text" initial={{ opacity: 1 }} animate={loading ? { opacity: 0 } : { opacity: 1 }}>
                  Voir maintenant
                </motion.p>

                <motion.div
                  className="btn-loader absolute flex justify-center align-items-center top0 z-1"
                  initial={{ opacity: 0 }}
                  animate={loading ? { opacity: 1 } : { opacity: 0 }}
                >
                  <img src={whiteLoader} alt="chargement" />
                </motion.div>
              </div>
            </div>
          ) : (
            <video
              src={flashSaleContent.mediaContent && flashSaleContent.mediaContent[0]}
              autoPlay
              muted
              className="flash-sale-video video"
            />
          )}
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default FlashPopUp;
